import { render, staticRenderFns } from "./FloatingTable.vue?vue&type=template&id=2f0ffd46&scoped=true&"
import script from "./FloatingTable.vue?vue&type=script&lang=js&"
export * from "./FloatingTable.vue?vue&type=script&lang=js&"
import style0 from "./FloatingTable.vue?vue&type=style&index=0&id=2f0ffd46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ffd46",
  null
  
)

export default component.exports